/* eslint-disable no-unused-vars */

global.usernameKey = function(e){
  return /^[a-zA-Z0-9@+.]$/g.test(String.fromCharCode(e.which))
}